import classNames from "classnames"

export const CODE_LENGTH = 6

interface Props {
  value: string
  onChange: (code: string) => void
  onComplete: (code: string) => void
  invalid?: boolean
  disabled?: boolean
}

export default function CodeInput({ value, onChange, onComplete, invalid, disabled }: Props) {
  const handleChange = (raw: string) => {
    const digits = raw.replace(/\D/g, "").slice(0, CODE_LENGTH)
    onChange(digits)

    // Submit as soon as the code is filled, including via SMS autofill
    if (digits.length === CODE_LENGTH && value.length < CODE_LENGTH) {
      onComplete(digits)
    }
  }

  return (
    <input
      className={classNames("form-control form-control-lg join-code", { "is-invalid": invalid })}
      type="text"
      inputMode="numeric"
      autoComplete="one-time-code"
      autoFocus
      maxLength={CODE_LENGTH}
      placeholder="000000"
      value={value}
      disabled={disabled}
      onChange={(e) => handleChange(e.target.value)}
    />
  )
}
